module.exports = __webpack_public_path__ + "img/icon-close.a658bc61.svg";